<template>

    <div v-if="user">
        <va-page-header>

            <div slot="title">
                <span>{{ _('Departments') }}</span>
            </div>

            <div slot="actions">
                <div style="display: flex; align-items: center">
                    <va-input v-if="user && user.get('type') == 'admin'" style="margin-right: 10px"
                        @change="searchDepartment" v-model="searchString" :placeholder="_('Search')" icon="search"
                        showClean></va-input>
                    <va-button @click.native="navigate('/departments/new')" type="primary" size="lg"
                        v-if="user.get('roles').includes('admin')">
                        {{ _('NEW DEPARTMENT') }}</va-button>
                </div>

            </div>

        </va-page-header>

        <div v-if="allDepartmentsCount !== 0">
            <va-row :gutter="12">
                <va-column :lg="12" :sm="12">
                    <va-table hover fullWidth class="datatable">
                        <table :dir="getDirectionStatus">
                            <thead>
                                <tr>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        {{ _('Name') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        {{ _('Manager') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        {{ _('Created By') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="department in perPageDepartments">
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}"><a style="cursor:pointer"
                                            @click="navigate('/departments/' + department.department.id)">{{
                                            g_getLabel(department.department) }}</a></td>

                                    </td>

                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <div style="display: flex" v-if="department.managers.length !== 0">
                                            <div style=" margin-left: 10px">
                                                <va-tooltip v-for="(manager, index) in department.managers.slice(0, 10)"
                                                    :content="manager.get('name')" trigger="hover" placement="top">
                                                    <img width="30px" height="30px" v-if="manager.get('profilePic')"
                                                        style="display:inline-block; margin-left: -10px; border-radius: 100px; border:1px solid #fff;"
                                                        :src="manager.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')" />
                                                </va-tooltip>
                                            </div>

                                            <va-dropdown triggerEvent="hover" v-if="department.managers.length > 3">
                                                <div slot="trigger">
                                                    <span
                                                        style="display:inline-block; line-height: 27px; text-align: center; margin-left:-5px; background:#d8d8d8; border:1px solid #fff; border-radius: 15px; width:30px; height:30px;">...</span>
                                                </div>
                                                <div style="padding: 10px; min-width: 350px;">
                                                    <div v-for="(manager, index) in department.managers"
                                                        style="margin: 5px 0">
                                                        <va-row :gutter="0">
                                                            <va-column :lg="12" :md="12" :sm="12" :xs="12">
                                                                <div style="position: relative;">

                                                                    <div>
                                                                        <img v-if="manager.get('profilePic')"
                                                                            width="35px" height="35px"
                                                                            style="margin-right: 10px; border-radius: 100px;"
                                                                            :src="manager.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')">
                                                                    </div>

                                                                    <span
                                                                        :class="{ltrName: true, rtlName: getDirectionStatus == 'rtl'}">{{
                                                                            manager.get('name')}}</span>
                                                                    <span
                                                                        :class="{ltrUsername: true, rtlUsername: getDirectionStatus == 'rtl'}">{{manager.get('username')}}</span>
                                                                </div>
                                                            </va-column>
                                                        </va-row>
                                                        <hr>
                                                    </div>
                                                </div>
                                            </va-dropdown>
                                        </div>
                                        <va-lozenge v-else type="danger" bold>{{ _('No Manager') }}</va-lozenge>

                                    </td>

                                    <td>
                                        <va-tooltip v-if="department.department.get('createdBy')"
                                            :content="department.department.get('createdBy').get('name')"
                                            trigger="hover" placement="top">
                                            <img width="30px" height="30px"
                                                v-if="department.department.get('createdBy').get('profilePic')"
                                                style="display:inline-block;  border-radius: 100px; border:1px solid #fff;"
                                                :src="department.department.get('createdBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')" />
                                        </va-tooltip>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </va-table>
                </va-column>
            </va-row>

            <!-- <va-row :gutter="12" v-if="user.get('type') == 'admin'">
                <va-column :lg="6" :sm="6">
                    <div style="display: flex">
                        <v-page :class="{no_click: allDepartmentsCount==0}" :key="$route.path"
                            :total-row="allDepartmentsCount" @page-change="paginate"></v-page>

                        <va-button style="margin-left: 10px" @click.native="paginate({pageNumber: page})">
                            <va-icon type="sync-alt"></va-icon>
                        </va-button>
                    </div>
                </va-column>
            </va-row> -->
        </div>
        <div v-else class="deadCenter">
            <p>{{ _('No department available') }}</p>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";

    export default {

        data() {
            return {
                page: 1,
                allDepartmentsCount: null,
                perPageDepartments: [],
                searchString: ''
            }
        },


        computed: {
            ...mapGetters(["user", 'getSystemLanguage', 'getDirectionStatus', 'getUserDepartmentsFromState']),

        },


        methods: {

            async fetchManagers(department) {
                let q = new Parse.Query('User')
                q.equalTo('departments', makePointer('Department', department.id))
                q.equalTo('type', 'manager')
                let managers = await q.find()
                return managers

            },

            async searchDepartment() {
                this.perPageDepartments = [];
                if (this.searchString) {
                    if (this.user.get('type') == 'admin') {
                        var conditions = [];
                        var orTemp = [];
                        let regex = new RegExp(`^.*${this.searchString}.*`, "i");
                        orTemp.push(new Parse.Query('Department').matches('label_english', regex))
                        orTemp.push(new Parse.Query('Department').matches('label_pashto', regex))
                        orTemp.push(new Parse.Query('Department').matches('label_dari', regex))
                        conditions.push(Parse.Query.or(...orTemp))
                        var mainQuery = Parse.Query.and(...conditions);
                        mainQuery.descending('createdAt')
                        mainQuery.include('createdBy')
                        let result = await mainQuery.find()
                        if (result.length != 0) {
                            for (const key in result) {
                                let managers = await this.fetchManagers(result[key])
                                this.perPageDepartments.push({ department: result[key], managers: managers })
                            }
                        }
                    }
                }
                this.$store.commit("setLoading", false);
            },

            async fetchDepartments(pageNumber) {
                this.perPageDepartments = [];
                if (this.user.get('type') == 'admin') {
                    let q = new Parse.Query('Department')
                    q.descending('createdAt')

                    // q.skip((pageNumber - 1) * 25)
                    // q.limit(25)
                    q.include('createdBy')
                    let result = await q.find()
                    if (result.length != 0) {
                        for (const key in result) {
                            let managers = await this.fetchManagers(result[key])
                            this.perPageDepartments.push({ department: result[key], managers: managers })
                        }
                    }
                } else {
                    if (this.getUserDepartmentsFromState && this.getUserDepartmentsFromState.length != 0) {
                        for (const key in this.getUserDepartmentsFromState) {
                            let managers = await this.fetchManagers(this.getUserDepartmentsFromState[key])
                            this.perPageDepartments.push({ department: this.getUserDepartmentsFromState[key], managers: managers })
                        }
                    }
                }

                this.$store.commit("setLoading", false);
            },

            async fetchDepartmentsCount() {
                if (this.user.get('type') == 'admin') {
                    let q = new Parse.Query('Department')
                    this.allDepartmentsCount = await q.count()
                } else {
                    if (this.getUserDepartmentsFromState) {
                        this.allDepartmentsCount = this.getUserDepartmentsFromState.length
                    }
                }
            },

            navigate(to) {
                this.$router.push(to);
            },

            async paginate(page) {
                this.page = page.pageNumber
                this.$store.commit("setLoading", true);
                if (this.user != null && this.user.get('type') != 'guest') {
                    await this.fetchDepartments(page.pageNumber)
                    await this.fetchDepartmentsCount();
                }
            },
        },


        async mounted() {

            this.$store.commit("setLoading", true);
            if (this.user != null && (this.user.get('type') == 'manager' || this.user.get('type') == 'admin')) {
                await this.fetchDepartmentsCount();
                await this.fetchDepartments(1)
            }
            this.$store.commit("setLoading", false);
        }
    };
</script>

<style>
</style>